import { render, staticRenderFns } from "./changeInfo.vue?vue&type=template&id=70ae5fd4&"
import script from "./changeInfo.vue?vue&type=script&lang=js&"
export * from "./changeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports